import {Autocomplete, Grid} from "@mui/material";
import { useFormik } from "formik";
import React, {useEffect, useState} from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import * as Yup from "yup";
import { ErrorToaast, SuccessToaast } from "../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import {VehicleModel} from "../../Api/Models/Vehicle";
import {TarefeModel} from "../../Api/Models/Tarefe";
import {ServiceModel} from "../../Api/Models/ServiceModel";
import DeleteDialog from "./components/DeleteDialog";

const validationSchema = Yup.object().shape({
    title: Yup.string()
        .typeError("عنوان الزامی است")
        .required("عنوان  الزامی است"),

    vehicleTypeId: Yup.number()
        .typeError("وسیله نقلیه الزامی است")
        .required("وسیله نقلیه الزامی است"),


    serviceTypeId: Yup.number()
        .typeError("سرویس الزامی است")
        .required("سرویس الزامی است")
        .nullable(),

    year: Yup.string().required("سال  الزامی است "),

    amountType: Yup.number()
        .typeError(" نوع مقدار الزامی است")
        .required(" نوع مقدار الزامی است"),
    fixedAmount: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),
    percentValue: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),
    perDayAmount: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),
    perHourAmount: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),


});
export default function Tarif() {
    const tarefemodel = new TarefeModel();
    const [searched, setSearched] = useState<any>([]);
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [services, setServices] = useState<any[]>([]);
    const [editable, setEditable] = useState<number>(0);
    const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });
     useEffect(() => {
   loadDatas()
         load()
    }, []);
    const load=async ()=>{
        try {
            const data=await tarefemodel.GetAll()
            setSearched(data.data.data);
        }catch(e) {
            console.log(e)
        }
    }
    const loadDatas=async ()=>{
        const modelService=new ServiceModel()
        const modelVehicle=new VehicleModel()
        try {
            const service=await modelService.GetAll()
            const vehicle=await modelVehicle.GetAll()
            setServices(service.data.data)
            setVehicles(vehicle.data.data)

            // console.log(service.data.data,vehicle.data.data)
        }
        catch {

        }
    }

    const formik = useFormik({
        initialValues: {
            title:'',
            vehicleTypeId: null,
            serviceTypeId: null,
            year:'1404',
            amountType: null,
            fixedAmount: null,
            percentValue: null,
            perDayAmount: null,
            perHourAmount: null,
            isActive: true
        },
        validationSchema,
        onSubmit: (items) => {
            if (editable !== 0) {
                // if (!items.isDelete) {
                //     ErrorToaast("وضعیت غیر فعال میباشد");
                //     return;
                // }
               tarefemodel
                    .EditData({ ...formik.values, id: editable })
                    .then((r) => {
                        load()
                        SuccessToaast("با موفقیت ویرایش شد")
                    })
                    .catch((e) => {
                        console.log(e)
                        ErrorToaast("خطا در برقراری ارتباط");
                    });
            } else {
                tarefemodel
                    .SubmitData(items)
                    .then((r) => {
                        load()
                        SuccessToaast("با موفقیت اضافه شد")
                    })
                    .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
            }
            formik.resetForm();
            setEditable(0);
        },
    });
    const handleSearch = () => {
        tarefemodel
            .GetSearch(
                formik.values.title,
                formik.values.vehicleTypeId,
                formik.values.serviceTypeId,
                formik.values.year,
                formik.values.amountType,
                formik.values.fixedAmount,
                formik.values.percentValue,
                formik.values.perDayAmount,
                formik.values.perHourAmount,

            ).then((r) => {
            setSearched(r.data.data);
        })
            .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
    };
    const years = Array.from({ length: 21 }, (_, i) => (1390 + i).toString());

    const handleRowClick = (data: any) => {
        formik.setFieldValue("title", data.title);
        formik.setFieldValue("vehicleTypeId", data.vehicleTypeId);
        formik.setFieldValue("serviceTypeId", data.serviceTypeId);
        formik.setFieldValue("year", data.year);
        formik.setFieldValue("amountType", data.amountType);
        formik.setFieldValue("fixedAmount", data.fixedAmount);
        formik.setFieldValue("percentValue", data.percentValue);
        formik.setFieldValue("perDayAmount", data.perDayAmount);
        formik.setFieldValue("perHourAmount", data.perHourAmount);
    };
     enum TariffAmountType {
        'ثابت' = 1,
        'درصدی' = 2,
        'روزانه' = 3,
        'ساعتی' = 4,
    }
    const tariffOptions = Object.entries(TariffAmountType)
        .filter(([key, value]) => isNaN(Number(key)))
        .map(([key, value]) => ({ label: key, value }));
    return (
        <DashboardLayout>
            <DashboardNavbar name={" مشخصات  تعرفه ها   "} />
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
                    <MDTypography fontWeight="bold" fontSize="14px">
                        مشخصات تعرفه ها
                    </MDTypography>
                    <MDDivider />
                    <MDBox py={2}>
                        <Grid container spacing={2} textAlign={"center"}>

                            <Grid container item xs={4} alignItems="center">
                                <Grid item container xs={12}>
                                    <MDTypography fontSize="15px"> عنوان</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="title"
                                        value={formik.values.title}
                                        error={formik.touched.title && Boolean(formik.errors.title)}
                                        helperText={formik.touched.title && formik.errors.title || ' '}
                                    />
                                </Grid>
                                </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid item container  xs={12}>
                                    <MDTypography fontSize="15px"> وسیله نقلیه  </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <Autocomplete
                                        onChange={(event, value) => {
                                            formik.setFieldValue('vehicleTypeId', value ? value.id : '');
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={vehicles?.find(option => option?.id === formik.values.vehicleTypeId) || null}
                                        options={vehicles}
                                        getOptionLabel={(option) => option?.name}
                                        renderInput={(params) => (
                                            <MDInput
                                                {...params}
                                                fullWidth
                                                size="small"
                                                name="vehicleTypeId"
                                                error={formik.touched.vehicleTypeId && Boolean(formik.errors.vehicleTypeId)}
                                                helperText={formik.touched.vehicleTypeId && formik.errors.vehicleTypeId || ' '}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid item container  xs={12}>
                                    <MDTypography fontSize="15px">نوع سرویس  </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <Autocomplete
                                        onChange={(event, value) => {
                                            formik.setFieldValue('serviceTypeId', value ? value.id : '');
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={services?.find(option => option?.id === formik.values.serviceTypeId) || null}
                                        options={services}
                                        getOptionLabel={(option) => option?.name}
                                        renderInput={(params) => (
                                            <MDInput
                                                {...params}
                                                fullWidth
                                                size="small"
                                                name="serviceTypeId"
                                                error={formik.touched.serviceTypeId && Boolean(formik.errors.serviceTypeId)}
                                                helperText={formik.touched.serviceTypeId && formik.errors.serviceTypeId || ' '}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid item container  xs={12}>
                                    <MDTypography fontSize="15px">سال</MDTypography>
                                </Grid>
                                <Grid item flex={1}>

                                    <Autocomplete
                                        options={years}
                                        value={formik.values.year}
                                        disableClearable={true}
                                        getOptionLabel={(option) => option.toString()}
                                        onChange={(e, value) => formik.setFieldValue("year", value)}
                                        renderInput={(params) => (
                                            <MDInput
                                                {...params}
                                                size="small"
                                                name={'year'}
                                                error={formik.touched.year && Boolean(formik.errors.year)}
                                                helperText={formik.touched.year && formik.errors.year || ' '}
                                            />
                                        )}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                            <Grid item container  xs={12}>
                                <MDTypography fontSize="15px">نوع مقدار</MDTypography>
                            </Grid>
                            <Grid item flex={1}>
                                <Autocomplete
                                    options={tariffOptions}
                                    onChange={(event, value) => {
                                        formik.setFieldValue('amountType', value?value.value:1);
                                    }}
                                    value={tariffOptions?.find(option => option?.value === formik.values.amountType) || null}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) =>
                                        <MDInput
                                            {...params}
                                            fullWidth
                                            size="small"
                                            name="amountType"
                                            error={formik.touched.amountType && Boolean(formik.errors.amountType)}
                                            helperText={formik.touched.amountType && formik.errors.amountType || ' '}
                                        />}
                                />

                            </Grid>
                        </Grid>
                            {formik.values.amountType===1?<Grid container item xs={4} alignItems="center">
                                <Grid item container xs={12}>
                                    <MDTypography fontSize="15px">مقدار ثابت</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="fixedAmount"
                                        value={formik.values.fixedAmount}
                                        error={formik.touched.fixedAmount && Boolean(formik.errors.fixedAmount)}
                                        helperText={formik.touched.fixedAmount && formik.errors.fixedAmount || ' '}
                                    />
                                </Grid>
                            </Grid>:formik.values.amountType===2?<Grid container item xs={4} alignItems="center">
                                <Grid item container xs={12}>
                                    <MDTypography fontSize="15px">مقدار درصدی</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="percentValue"
                                        value={formik.values.percentValue}
                                        error={formik.touched.percentValue && Boolean(formik.errors.percentValue)}
                                        helperText={formik.touched.percentValue && formik.errors.percentValue || ' '}
                                    />
                                </Grid>
                            </Grid>:formik.values.amountType===3?<Grid container item xs={4} alignItems="center">
                                <Grid item container xs={12}>
                                    <MDTypography fontSize="15px">مقدار روزانه</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="perDayAmount"
                                        value={formik.values.perDayAmount}
                                        error={formik.touched.perDayAmount && Boolean(formik.errors.perDayAmount)}
                                        helperText={formik.touched.perDayAmount && formik.errors.perDayAmount || ' '}
                                    />
                                </Grid>
                            </Grid>:formik.values.amountType===4?<Grid container item xs={4} alignItems="center">
                                <Grid item container xs={12}>
                                    <MDTypography fontSize="15px">مقدار ساعتی</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="perHourAmount"
                                        value={formik.values.perHourAmount}
                                        error={formik.touched.perHourAmount && Boolean(formik.errors.perHourAmount)}
                                        helperText={formik.touched.perHourAmount && formik.errors.perHourAmount || ' '}
                                    />
                                </Grid>
                            </Grid>:null}
                        </Grid>
                    </MDBox>
                </MDBox>
                <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
                    <MDBox>
                        <Grid container columnGap={4} columns={10} justifyContent="center">
                            <Grid item xs={2}>
                                <MDButton
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        formik.resetForm();
                                        setEditable(0);
                                    }}
                                    color="success"
                                >
                                    جدید
                                </MDButton>
                            </Grid>
                            <Grid item xs={2}>
                                <MDButton fullWidth variant="contained" color="warning" type="submit">
                                    ثبت
                                </MDButton>
                            </Grid>

                            <Grid item xs={2}>
                                <MDButton fullWidth variant="contained" color="primary" onClick={handleSearch}>
                                    جستجو
                                </MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                    <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={4} border="2px #5b5b5b solid">
                        <MDBox bgColor="#eeeeee" px={1}>
                            <Grid container textAlign="center">
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}>عنوان</MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}>نام وسیله نقلیه  </MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}>نام سرویس </MDTypography>
                                </Grid>
                                <Grid item xs={1}>
                                    <MDTypography fontSize={"14px"}>سال</MDTypography>
                                </Grid>
                                <Grid item xs={1}>
                                    <MDTypography fontSize={"14px"}>نوع مقدار </MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}> مقدار </MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}> حذف </MDTypography>
                                </Grid>
                            </Grid>
                        </MDBox>
                        {searched.length > 0 &&
                            searched.map((data: any, index: number) => {
                                return (
                                    <MDBox
                                        bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                                        px={1}
                                        key={uuid()}
                                        onClick={() => {
                                            handleRowClick(data);
                                            setEditable(data.id);
                                        }}
                                        sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                                    >
                                        <Grid container textAlign="center">
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{data.title ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{(vehicles.find((item)=>item.id===data.vehicleTypeId))?.name ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{(services.find((item)=>item.id===data.serviceTypeId))?.name ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <MDTypography fontSize={"14px"}>{data.year ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <MDTypography fontSize={"14px"}>{(tariffOptions.find((item)=>item.value===data.amountType))?.label ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{data.fixedAmount??data.perHourAmount??data.perDayAmount??data.percentValue ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDBox
                                                    onClick={(e: any) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setDeleteOpen({ open: true, id: data.id });
                                                    }}
                                                >
                                                    <DeleteIcon color="error" />
                                                </MDBox>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                );
                            })}
                    </MDBox>

                </MDBox>
                <DeleteDialog
                    open={deleteOpen.open}
                    id={deleteOpen.id}
                    setClose={() => setDeleteOpen({ id: 0, open: false })}
                    onDone={() => {
                        setDeleteOpen({ open: false, id: 0 });
                        load()
                    }}
                />
            </MDBox>
        </DashboardLayout>
    );
}
